import script from "./newCashPaymentButton.vue?vue&type=script&setup=true&lang=js"
export * from "./newCashPaymentButton.vue?vue&type=script&setup=true&lang=js"

import "./newCashPaymentButton.vue?vue&type=style&index=0&id=3b622408&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b622408"]])

export default __exports__